import type { companies as enCompanies } from "../en/companies";

export const companies: typeof enCompanies = {
  pageHeading: "Aziende",
  createdBanner: {
    body: "creata con un contatto e una sede — è pronta per un preventivo.",
    createQuoteLink: "Crea un preventivo per questa azienda",
  },
  loadError:
    "Non siamo riusciti a caricare le aziende. Il B2B potrebbe non essere attivo su questo negozio, oppure gli ambiti di autorizzazione non sono ancora stati concessi.",
  intro:
    "Ogni preventivo è indirizzato a un'azienda B2B (il record cliente business nativo di Shopify). Creane una direttamente da qui — Quote Desk imposta il contatto e la sede di cui un acquirente ha bisogno per accettare un preventivo — oppure gestiscile dall'admin Shopify in Clienti → Aziende.",
  emptyState: {
    heading: "Ancora nessuna azienda — crea la prima",
    body: "Devi avere almeno un'azienda prima di poter inviare un preventivo. Compila il modulo qui sotto, oppure crea un'azienda demo usa e getta per provare l'intero flusso.",
    sampleButton: "Crea un'azienda di esempio (dati demo)",
    manualRoutePrefix: "Preferisci la via manuale?",
    manualRouteLink: "La guida di Shopify all'attivazione del B2B",
  },
  list: {
    heading: "Le tue aziende B2B",
    countsLine: "{{locations}} sedi · {{contacts}} contatti",
  },
  createSection: {
    headingFirst: "Crea un'azienda",
    headingAdditional: "Aggiungi un'altra azienda",
  },
  form: {
    nameLabel: "Nome azienda",
    namePlaceholder: "es. Acme Ingrosso",
    firstNameLabel: "Nome del contatto",
    lastNameLabel: "Cognome del contatto",
    emailLabel: "Email del contatto",
    emailHelpText: "L'acquirente che riceverà i preventivi. Shopify crea per lui/lei un record cliente.",
    locationLabel: "Nome sede (opzionale)",
    locationPlaceholder: "Il valore predefinito è “<azienda> — sede principale”",
    locationHelpText: "Le aziende hanno bisogno di una sede prima che gli acquirenti possano accettare i preventivi — la creiamo noi per te.",
    submitButton: "Crea azienda",
    errors: {
      nameRequired: "Il nome dell'azienda è obbligatorio.",
      firstNameRequired: "Il nome del contatto è obbligatorio.",
      lastNameRequired: "Il cognome del contatto è obbligatorio.",
      invalidEmail: "Inserisci un'email di contatto valida.",
      invalidInput: "Dati non validi.",
      createFailed:
        "Non è stato possibile creare l'azienda — il B2B potrebbe non essere ancora disponibile su questo negozio. Puoi anche creare aziende dall'admin Shopify in Clienti → Aziende.",
      shopifyRejected: "Shopify ha rifiutato l'azienda.",
    },
  },
  detail: {
    notFoundHeading: "Azienda non trovata",
    notFoundBody: "Impossibile caricare l'azienda {{id}}.",
    contactsHeading: "Contatti",
    locationsHeading: "Sedi",
    priceListHeading: "Listino prezzi B2B",
    priceListDescription:
      "Assegna un listino prezzi e ogni nuovo preventivo per questa azienda precompilerà ciascuna riga da esso — resta comunque possibile modificare qualsiasi riga prima dell'invio.",
    noPriceLists: {
      body: "Ancora nessun listino prezzi attivo.",
      createLink: "Crea un listino prezzi",
      suffix: "per offrire a questa azienda condizioni B2B negoziate.",
    },
    priceListSelectLabel: "Listino prezzi assegnato",
    noneOption: "Nessuno (usa i prezzi del catalogo)",
    saveAssignmentButton: "Salva assegnazione",
    actionsHeading: "Azioni",
    createQuoteButton: "Crea un preventivo per questa azienda",
    messages: {
      removed: "Listino prezzi rimosso da questa azienda.",
      assigned: "Listino prezzi assegnato. I nuovi preventivi per questa azienda si precompileranno da esso.",
      assignFailed: "Quel listino prezzi o quell'azienda non esistono più.",
    },
  },
};
